import React from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import ShareIcons from "../icons/ShareIcons";
import { copyToClipboard } from "../../utils/copyToClipboard";
import ArticleHeaderStyles from "../../styles/ArticleHeaderStyles";

const ArticleHeader = ({
  color,
  data: {
    title,
    eyebrow,
    date,
    subHeader,
    slug,
    author,
    coAuthors,
    writtenBy,
    interviewer,
  },
  currentUrl,
}) => {
  const copyLink = () => {
    copyToClipboard(currentUrl);
  };

  return (
    <ArticleHeaderStyles>
      <div className={`article__banner article__banner--${color}`}></div>
      <div className="article">
        {eyebrow && <h4 className="article__eyebrow">{eyebrow}</h4>}
        <h1 className="article__header">{title}</h1>
        <h2 className="article__sub-header">{subHeader}</h2>
        <div className="article__share-date-divider">
          <div className="article__share-collection">
            <div onClick={copyLink} className="article__share-item">
              <div className="article__share-item--copy">
                <ShareIcons icon="copy" />
              </div>
            </div>
            <div className="article__share-item">
              <TwitterShareButton
                children={
                  <>
                    <div>
                      <ShareIcons icon="twitter" />
                    </div>
                  </>
                }
                title={title}
                url={`https://www.table-sage.com${currentUrl}`}
              />
            </div>
            <div className="article__share-item">
              <FacebookShareButton
                children={
                  <>
                    <div>
                      <ShareIcons icon="facebook" />
                    </div>
                  </>
                }
                quote={title}
                url={`https://www.table-sage.com${currentUrl}`}
              />
            </div>
            <div className="article__share-item">
              <WhatsappShareButton
                id="whatsapp-btn"
                children={
                  <>
                    <div>
                      <ShareIcons icon="whatsapp" />{" "}
                    </div>
                  </>
                }
                title={title}
                separator="&#x000D;"
                url={`https://www.table-sage.com${currentUrl}`}
              />
            </div>
          </div>
          <div>
            {interviewer && (
              <p className="article__byline">Interview by {interviewer}</p>
            )}
            {writtenBy && (
              <p className="article__byline">Written by {writtenBy}</p>
            )}
            {author && <p className="article__byline">By {author}</p>}
            {coAuthors && <p className="article__byline">{coAuthors}</p>}
            <p className="article__date">{date}</p>
          </div>
        </div>
      </div>
    </ArticleHeaderStyles>
  );
};

export default ArticleHeader;
